// src/data/mobility.ts
// MRN Mobility Intelligence — mock data for UI prototype
// Source: MRN Mobility Intelligence (physical world behavior tied to MRN Person ID)

// ── POI Library ───────────────────────────────────────────────
export interface POI {
  poi_id:    string;
  name:      string;
  brand:     string;
  naics_code:string;
  category:  string;
  lat:       number;
  lng:       number;
  address:   string;
  city:      string;
  state:     string;
  zip:       string;
  retailer?: string;  // which demo retailer owns this location
}

export const POI_LIBRARY: POI[] = [
  // ── Midwest Hardware locations ────────────────────────────
  { poi_id:"mhw-001", name:"Midwest Hardware — Lincoln Square",   brand:"Midwest Hardware", naics_code:"444110", category:"Home Improvement", lat:41.9681, lng:-87.7183, address:"4501 N Lincoln Ave",    city:"Chicago",       state:"IL", zip:"60625", retailer:"org-mhw" },
  { poi_id:"mhw-002", name:"Midwest Hardware — Evanston",         brand:"Midwest Hardware", naics_code:"444110", category:"Home Improvement", lat:42.0451, lng:-87.6877, address:"818 Church St",         city:"Evanston",      state:"IL", zip:"60201", retailer:"org-mhw" },
  { poi_id:"mhw-003", name:"Midwest Hardware — Oak Park",         brand:"Midwest Hardware", naics_code:"444110", category:"Home Improvement", lat:41.8850, lng:-87.7845, address:"130 S Oak Park Ave",    city:"Oak Park",      state:"IL", zip:"60302", retailer:"org-mhw" },

  // ── FreshMart Grocery locations ───────────────────────────
  { poi_id:"fmg-001", name:"FreshMart Grocery — Wicker Park",     brand:"FreshMart Grocery",naics_code:"445110", category:"Grocery",          lat:41.9088, lng:-87.6776, address:"1640 N Damen Ave",     city:"Chicago",       state:"IL", zip:"60647", retailer:"org-fmg" },
  { poi_id:"fmg-002", name:"FreshMart Grocery — Lincoln Park",    brand:"FreshMart Grocery",naics_code:"445110", category:"Grocery",          lat:41.9242, lng:-87.6441, address:"2232 N Clark St",      city:"Chicago",       state:"IL", zip:"60614", retailer:"org-fmg" },
  { poi_id:"fmg-003", name:"FreshMart Grocery — River North",     brand:"FreshMart Grocery",naics_code:"445110", category:"Grocery",          lat:41.8933, lng:-87.6320, address:"430 W Erie St",        city:"Chicago",       state:"IL", zip:"60654", retailer:"org-fmg" },

  // ── StyleNow Apparel locations ────────────────────────────
  { poi_id:"sna-001", name:"StyleNow Apparel — Magnificent Mile", brand:"StyleNow Apparel", naics_code:"448110", category:"Apparel",          lat:41.8964, lng:-87.6262, address:"900 N Michigan Ave",   city:"Chicago",       state:"IL", zip:"60611", retailer:"org-sna" },
  { poi_id:"sna-002", name:"StyleNow Apparel — Oak Brook",        brand:"StyleNow Apparel", naics_code:"448110", category:"Apparel",          lat:41.8478, lng:-87.9548, address:"100 Oakbrook Center",  city:"Oak Brook",     state:"IL", zip:"60523", retailer:"org-sna" },
  { poi_id:"sna-003", name:"StyleNow Apparel — Schaumburg",       brand:"StyleNow Apparel", naics_code:"448110", category:"Apparel",          lat:42.0334, lng:-88.0834, address:"5 Woodfield Mall",     city:"Schaumburg",    state:"IL", zip:"60173", retailer:"org-sna" },

  // ── Competitor — Home Improvement ────────────────────────
  { poi_id:"cmp-001", name:"Home Depot — Chicago North",          brand:"Home Depot",       naics_code:"444110", category:"Home Improvement", lat:41.9756, lng:-87.7012, address:"2570 N Elston Ave",    city:"Chicago",       state:"IL", zip:"60647" },
  { poi_id:"cmp-002", name:"Home Depot — Evanston",               brand:"Home Depot",       naics_code:"444110", category:"Home Improvement", lat:42.0389, lng:-87.7012, address:"1300 Chicago Ave",     city:"Evanston",      state:"IL", zip:"60202" },
  { poi_id:"cmp-003", name:"Lowe's — Skokie",                     brand:"Lowe's",           naics_code:"444110", category:"Home Improvement", lat:42.0333, lng:-87.7340, address:"4649 W Oakton St",     city:"Skokie",        state:"IL", zip:"60076" },
  { poi_id:"cmp-004", name:"Lowe's — Bridgeview",                 brand:"Lowe's",           naics_code:"444110", category:"Home Improvement", lat:41.7445, lng:-87.8057, address:"9000 S Harlem Ave",    city:"Bridgeview",    state:"IL", zip:"60455" },

  // ── Competitor — Grocery ──────────────────────────────────
  { poi_id:"cmp-005", name:"Whole Foods — Lincoln Park",          brand:"Whole Foods",      naics_code:"445110", category:"Grocery",          lat:41.9298, lng:-87.6441, address:"1550 N Fremont St",    city:"Chicago",       state:"IL", zip:"60622" },
  { poi_id:"cmp-006", name:"Whole Foods — Gold Coast",            brand:"Whole Foods",      naics_code:"445110", category:"Grocery",          lat:41.9032, lng:-87.6309, address:"30 W Huron St",        city:"Chicago",       state:"IL", zip:"60610" },
  { poi_id:"cmp-007", name:"Trader Joe's — Wicker Park",          brand:"Trader Joe's",     naics_code:"445110", category:"Grocery",          lat:41.9044, lng:-87.6776, address:"1840 N Damen Ave",     city:"Chicago",       state:"IL", zip:"60647" },
  { poi_id:"cmp-008", name:"Mariano's — River North",             brand:"Mariano's",        naics_code:"445110", category:"Grocery",          lat:41.8889, lng:-87.6354, address:"300 W Grand Ave",      city:"Chicago",       state:"IL", zip:"60654" },

  // ── Competitor — Apparel ──────────────────────────────────
  { poi_id:"cmp-009", name:"Nike — Magnificent Mile",             brand:"Nike",             naics_code:"448110", category:"Apparel",          lat:41.8978, lng:-87.6248, address:"669 N Michigan Ave",   city:"Chicago",       state:"IL", zip:"60611" },
  { poi_id:"cmp-010", name:"Zara — Magnificent Mile",             brand:"Zara",             naics_code:"448110", category:"Apparel",          lat:41.8966, lng:-87.6261, address:"700 N Michigan Ave",   city:"Chicago",       state:"IL", zip:"60611" },
  { poi_id:"cmp-011", name:"H&M — State Street",                  brand:"H&M",              naics_code:"448110", category:"Apparel",          lat:41.8823, lng:-87.6278, address:"22 S State St",        city:"Chicago",       state:"IL", zip:"60603" },

  // ── Category-adjacent venues ──────────────────────────────
  { poi_id:"adj-001", name:"Home Sense — Niles",                  brand:"Home Sense",       naics_code:"442299", category:"Home Furnishings", lat:42.0167, lng:-87.7948, address:"9800 N Milwaukee Ave", city:"Niles",         state:"IL", zip:"60714" },
  { poi_id:"adj-002", name:"IKEA — Bolingbrook",                  brand:"IKEA",             naics_code:"442110", category:"Furniture",        lat:41.7048, lng:-88.0682, address:"750 E Boughton Rd",    city:"Bolingbrook",   state:"IL", zip:"60440" },
  { poi_id:"adj-003", name:"Costco — Chicago",                    brand:"Costco",           naics_code:"452319", category:"Warehouse Club",   lat:41.8488, lng:-87.6632, address:"2746 N Clybourn Ave",  city:"Chicago",       state:"IL", zip:"60614" },
  { poi_id:"adj-004", name:"Target — Wicker Park",                brand:"Target",           naics_code:"452311", category:"Mass Retail",      lat:41.9095, lng:-87.6769, address:"1654 N Damen Ave",     city:"Chicago",       state:"IL", zip:"60647" },
  { poi_id:"adj-005", name:"Planet Fitness — Lincoln Square",     brand:"Planet Fitness",   naics_code:"713940", category:"Fitness",          lat:41.9671, lng:-87.7154, address:"4760 N Lincoln Ave",   city:"Chicago",       state:"IL", zip:"60625" },
  { poi_id:"adj-006", name:"Starbucks — Lincoln Park",            brand:"Starbucks",        naics_code:"722515", category:"Coffee",           lat:41.9251, lng:-87.6445, address:"2112 N Clark St",      city:"Chicago",       state:"IL", zip:"60614" },
  { poi_id:"adj-007", name:"Ace Hardware — Logan Square",         brand:"Ace Hardware",     naics_code:"444130", category:"Hardware",         lat:41.9217, lng:-87.7065, address:"2434 N Milwaukee Ave",  city:"Chicago",       state:"IL", zip:"60647" },
  { poi_id:"adj-008", name:"Binny's Beverage Depot",              brand:"Binny's",          naics_code:"445310", category:"Liquor Store",     lat:41.9250, lng:-87.6441, address:"1720 N Marcey St",     city:"Chicago",       state:"IL", zip:"60614" },
];

// ── Trade Area Data ───────────────────────────────────────────
export interface TradeAreaData {
  poi_id:                  string;
  location_name:           string;
  retailer_id:             string;
  total_monthly_visitors:  number;
  avg_distance_miles:      number;
  median_dwell_minutes:    number;
  competitor_overlap_pct:  number;
  top_origin_zips: {
    zip:      string;
    city:     string;
    visitors: number;
    pct:      number;
  }[];
  distance_bands: {
    band:    string;
    pct:     number;
    visitors:number;
  }[];
  visit_by_day: {
    day:      string;
    visitors: number;
  }[];
  visit_by_hour: {
    hour:     string;
    visitors: number;
  }[];
}

export const TRADE_AREA_DATA: TradeAreaData[] = [
  {
    poi_id:                 "mhw-001",
    location_name:          "Midwest Hardware — Lincoln Square",
    retailer_id:            "org-mhw",
    total_monthly_visitors: 18_420,
    avg_distance_miles:     3.8,
    median_dwell_minutes:   42,
    competitor_overlap_pct: 34,
    top_origin_zips: [
      { zip:"60625", city:"Lincoln Square",  visitors:3_840, pct:20.8 },
      { zip:"60618", city:"Irving Park",     visitors:2_920, pct:15.9 },
      { zip:"60613", city:"Uptown",          visitors:2_180, pct:11.8 },
      { zip:"60640", city:"Andersonville",   visitors:1_840, pct:10.0 },
      { zip:"60657", city:"Lakeview",        visitors:1_620, pct:8.8  },
    ],
    distance_bands: [
      { band:"0–1 mi",  pct:18, visitors:3_316  },
      { band:"1–2 mi",  pct:32, visitors:5_894  },
      { band:"2–5 mi",  pct:34, visitors:6_263  },
      { band:"5–10 mi", pct:12, visitors:2_210  },
      { band:"10+ mi",  pct:4,  visitors:737     },
    ],
    visit_by_day: [
      { day:"Mon", visitors:1_842 }, { day:"Tue", visitors:2_104 },
      { day:"Wed", visitors:2_318 }, { day:"Thu", visitors:2_540 },
      { day:"Fri", visitors:3_210 }, { day:"Sat", visitors:4_820 },
      { day:"Sun", visitors:1_586 },
    ],
    visit_by_hour: [
      { hour:"8am",  visitors:412  }, { hour:"9am",  visitors:684  },
      { hour:"10am", visitors:1_240 }, { hour:"11am", visitors:1_580 },
      { hour:"12pm", visitors:1_820 }, { hour:"1pm",  visitors:1_640 },
      { hour:"2pm",  visitors:1_420 }, { hour:"3pm",  visitors:1_580 },
      { hour:"4pm",  visitors:2_140 }, { hour:"5pm",  visitors:2_840 },
      { hour:"6pm",  visitors:2_420 }, { hour:"7pm",  visitors:1_240 },
      { hour:"8pm",  visitors:404   },
    ],
  },
  {
    poi_id:                 "fmg-001",
    location_name:          "FreshMart Grocery — Wicker Park",
    retailer_id:            "org-fmg",
    total_monthly_visitors: 42_180,
    avg_distance_miles:     1.4,
    median_dwell_minutes:   28,
    competitor_overlap_pct: 41,
    top_origin_zips: [
      { zip:"60647", city:"Wicker Park",     visitors:9_840, pct:23.3 },
      { zip:"60622", city:"Ukrainian Village",visitors:7_420, pct:17.6 },
      { zip:"60651", city:"Humboldt Park",   visitors:5_180, pct:12.3 },
      { zip:"60614", city:"Lincoln Park",    visitors:4_820, pct:11.4 },
      { zip:"60642", city:"River West",      visitors:3_640, pct:8.6  },
    ],
    distance_bands: [
      { band:"0–0.5 mi",pct:38, visitors:16_028 },
      { band:"0.5–1 mi",pct:28, visitors:11_810 },
      { band:"1–2 mi",  pct:22, visitors:9_280  },
      { band:"2–5 mi",  pct:10, visitors:4_218  },
      { band:"5+ mi",   pct:2,  visitors:844     },
    ],
    visit_by_day: [
      { day:"Mon", visitors:4_820 }, { day:"Tue", visitors:5_240 },
      { day:"Wed", visitors:6_180 }, { day:"Thu", visitors:5_840 },
      { day:"Fri", visitors:7_420 }, { day:"Sat", visitors:8_640 },
      { day:"Sun", visitors:4_040 },
    ],
    visit_by_hour: [
      { hour:"7am",  visitors:840  }, { hour:"8am",  visitors:1_820 },
      { hour:"9am",  visitors:2_840 }, { hour:"10am", visitors:3_420 },
      { hour:"11am", visitors:3_840 }, { hour:"12pm", visitors:4_820 },
      { hour:"1pm",  visitors:4_240 }, { hour:"2pm",  visitors:3_620 },
      { hour:"3pm",  visitors:3_840 }, { hour:"4pm",  visitors:4_420 },
      { hour:"5pm",  visitors:5_840 }, { hour:"6pm",  visitors:5_240 },
      { hour:"7pm",  visitors:3_420 }, { hour:"8pm",  visitors:1_420 },
      { hour:"9pm",  visitors:540   },
    ],
  },
  {
    poi_id:                 "sna-001",
    location_name:          "StyleNow Apparel — Magnificent Mile",
    retailer_id:            "org-sna",
    total_monthly_visitors: 28_640,
    avg_distance_miles:     6.2,
    median_dwell_minutes:   38,
    competitor_overlap_pct: 58,
    top_origin_zips: [
      { zip:"60611", city:"Streeterville",   visitors:4_820, pct:16.8 },
      { zip:"60614", city:"Lincoln Park",    visitors:3_840, pct:13.4 },
      { zip:"60657", city:"Lakeview",        visitors:3_240, pct:11.3 },
      { zip:"60610", city:"Gold Coast",      visitors:2_980, pct:10.4 },
      { zip:"60625", city:"Lincoln Square",  visitors:2_140, pct:7.5  },
    ],
    distance_bands: [
      { band:"0–1 mi",  pct:12, visitors:3_437  },
      { band:"1–3 mi",  pct:28, visitors:8_019  },
      { band:"3–7 mi",  pct:38, visitors:10_883 },
      { band:"7–15 mi", pct:16, visitors:4_582  },
      { band:"15+ mi",  pct:6,  visitors:1_718  },
    ],
    visit_by_day: [
      { day:"Mon", visitors:2_840 }, { day:"Tue", visitors:2_640 },
      { day:"Wed", visitors:3_120 }, { day:"Thu", visitors:3_480 },
      { day:"Fri", visitors:4_820 }, { day:"Sat", visitors:7_240 },
      { day:"Sun", visitors:4_500 },
    ],
    visit_by_hour: [
      { hour:"10am", visitors:1_240 }, { hour:"11am", visitors:2_180 },
      { hour:"12pm", visitors:3_420 }, { hour:"1pm",  visitors:3_840 },
      { hour:"2pm",  visitors:4_120 }, { hour:"3pm",  visitors:3_980 },
      { hour:"4pm",  visitors:3_640 }, { hour:"5pm",  visitors:3_120 },
      { hour:"6pm",  visitors:2_480 }, { hour:"7pm",  visitors:620   },
    ],
  },
];

// ── Cross-Shop Data ───────────────────────────────────────────
export interface CrossShopVenue {
  venue_name:      string;
  category:        string;
  share_of_trips:  number;   // % of retailer customers who also visit
  avg_dwell_minutes: number;
  monthly_overlap: number;   // unique persons who visit both
}

export interface CrossShopData {
  retailer_id:   string;
  retailer_name: string;
  venues:        CrossShopVenue[];
}

export const CROSS_SHOP_DATA: CrossShopData[] = [
  {
    retailer_id:   "org-mhw",
    retailer_name: "Midwest Hardware",
    venues: [
      { venue_name:"Costco",              category:"Warehouse Club",   share_of_trips:28.4, avg_dwell_minutes:62, monthly_overlap:5_232 },
      { venue_name:"Home Depot",          category:"Home Improvement", share_of_trips:22.1, avg_dwell_minutes:48, monthly_overlap:4_071 },
      { venue_name:"Target",              category:"Mass Retail",      share_of_trips:18.8, avg_dwell_minutes:34, monthly_overlap:3_463 },
      { venue_name:"IKEA",                category:"Furniture",        share_of_trips:12.4, avg_dwell_minutes:84, monthly_overlap:2_284 },
      { venue_name:"Ace Hardware",        category:"Hardware",         share_of_trips:8.6,  avg_dwell_minutes:22, monthly_overlap:1_584 },
      { venue_name:"Home Sense",          category:"Home Furnishings", share_of_trips:6.2,  avg_dwell_minutes:44, monthly_overlap:1_142 },
    ],
  },
  {
    retailer_id:   "org-fmg",
    retailer_name: "FreshMart Grocery",
    venues: [
      { venue_name:"Starbucks",           category:"Coffee",           share_of_trips:42.8, avg_dwell_minutes:18, monthly_overlap:18_053 },
      { venue_name:"Target",              category:"Mass Retail",      share_of_trips:31.4, avg_dwell_minutes:34, monthly_overlap:13_241 },
      { venue_name:"Whole Foods",         category:"Grocery",          share_of_trips:24.2, avg_dwell_minutes:26, monthly_overlap:10_208 },
      { venue_name:"Costco",              category:"Warehouse Club",   share_of_trips:18.8, avg_dwell_minutes:62, monthly_overlap:7_930 },
      { venue_name:"Binny's",             category:"Liquor Store",     share_of_trips:12.4, avg_dwell_minutes:20, monthly_overlap:5_230 },
      { venue_name:"Planet Fitness",      category:"Fitness",          share_of_trips:9.6,  avg_dwell_minutes:54, monthly_overlap:4_049 },
    ],
  },
  {
    retailer_id:   "org-sna",
    retailer_name: "StyleNow Apparel",
    venues: [
      { venue_name:"Nike",                category:"Apparel",          share_of_trips:38.4, avg_dwell_minutes:28, monthly_overlap:11_000 },
      { venue_name:"Zara",                category:"Apparel",          share_of_trips:32.1, avg_dwell_minutes:32, monthly_overlap:9_198 },
      { venue_name:"Sephora",             category:"Beauty",           share_of_trips:28.8, avg_dwell_minutes:24, monthly_overlap:8_248 },
      { venue_name:"Starbucks",           category:"Coffee",           share_of_trips:24.4, avg_dwell_minutes:18, monthly_overlap:6_988 },
      { venue_name:"Nordstrom",           category:"Dept. Store",      share_of_trips:18.2, avg_dwell_minutes:68, monthly_overlap:5_212 },
      { venue_name:"Planet Fitness",      category:"Fitness",          share_of_trips:12.4, avg_dwell_minutes:54, monthly_overlap:3_551 },
    ],
  },
];

// ── Foot Traffic Lift Studies ─────────────────────────────────
export interface FootTrafficLift {
  study_id:           string;
  campaign_id:        string;
  campaign_name:      string;
  retailer:           string;
  exposed_visit_rate: number;   // %
  control_visit_rate: number;   // %
  lift_pct:           number;
  p_value:            number;
  confidence:         number;   // %
  sample_size:        number;
  incremental_visits: number;
  cost_per_visit:     number;
}

export const FOOT_TRAFFIC_LIFT_SAMPLES: FootTrafficLift[] = [
  {
    study_id:           "fts-001",
    campaign_id:        "cmp-001",
    campaign_name:      "DeWalt Q2 Power Tools — Display",
    retailer:           "Midwest Hardware",
    exposed_visit_rate: 8.4,
    control_visit_rate: 3.2,
    lift_pct:           162.5,
    p_value:            0.004,
    confidence:         99.6,
    sample_size:        48_400,
    incremental_visits: 12_840,
    cost_per_visit:     24.32,
  },
  {
    study_id:           "fts-002",
    campaign_id:        "cmp-004",
    campaign_name:      "Kraft Mac & Cheese — Family Targeting",
    retailer:           "FreshMart Grocery",
    exposed_visit_rate: 12.8,
    control_visit_rate: 6.4,
    lift_pct:           100.0,
    p_value:            0.008,
    confidence:         99.2,
    sample_size:        84_200,
    incremental_visits: 28_420,
    cost_per_visit:     18.84,
  },
  {
    study_id:           "fts-003",
    campaign_id:        "cmp-007",
    campaign_name:      "Nike Air Max — Spring Launch",
    retailer:           "StyleNow Apparel",
    exposed_visit_rate: 6.2,
    control_visit_rate: 2.8,
    lift_pct:           121.4,
    p_value:            0.012,
    confidence:         98.8,
    sample_size:        32_800,
    incremental_visits: 8_240,
    cost_per_visit:     41.22,
  },
  {
    study_id:           "fts-004",
    campaign_id:        "cmp-009",
    campaign_name:      "Samsung Galaxy S26 — Launch",
    retailer:           "Midwest Hardware",
    exposed_visit_rate: 4.8,
    control_visit_rate: 2.2,
    lift_pct:           118.2,
    p_value:            0.018,
    confidence:         98.2,
    sample_size:        124_000,
    incremental_visits: 14_820,
    cost_per_visit:     52.84,
  },
  {
    study_id:           "fts-005",
    campaign_id:        "cmp-011",
    campaign_name:      "P&G Tide — Household Essentials",
    retailer:           "FreshMart Grocery",
    exposed_visit_rate: 14.2,
    control_visit_rate: 8.4,
    lift_pct:           69.0,
    p_value:            0.024,
    confidence:         97.6,
    sample_size:        196_000,
    incremental_visits: 42_840,
    cost_per_visit:     14.28,
  },
];

// ── Visit History Samples ─────────────────────────────────────
export interface VisitRecord {
  person_id:      string;
  poi_id:         string;
  timestamp:      string;
  dwell_minutes:  number;
  naics_code:     string;
  visit_type:     "primary" | "competitor" | "adjacent";
}

// Generate 50 realistic visit records
function makeVisit(personId: string, poiId: string, daysAgo: number, dwell: number, naics: string, type: VisitRecord["visit_type"]): VisitRecord {
  const d = new Date();
  d.setDate(d.getDate() - daysAgo);
  d.setHours(Math.floor(Math.random() * 12) + 8);
  return { person_id: personId, poi_id: poiId, timestamp: d.toISOString(), dwell_minutes: dwell, naics_code: naics, visit_type: type };
}

export const VISIT_HISTORY_SAMPLES: VisitRecord[] = [
  makeVisit("AA-001","mhw-001",2,  44,"444110","primary"),
  makeVisit("AA-001","adj-003",4,  58,"452319","adjacent"),
  makeVisit("AA-001","cmp-001",8,  51,"444110","competitor"),
  makeVisit("AA-002","fmg-001",1,  28,"445110","primary"),
  makeVisit("AA-002","cmp-005",3,  24,"445110","competitor"),
  makeVisit("AA-002","adj-006",5,  16,"722515","adjacent"),
  makeVisit("AA-003","sna-001",2,  42,"448110","primary"),
  makeVisit("AA-003","cmp-009",4,  32,"448110","competitor"),
  makeVisit("AA-003","cmp-010",6,  28,"448110","competitor"),
  makeVisit("AA-004","mhw-002",3,  38,"444110","primary"),
  makeVisit("AA-004","cmp-003",7,  46,"444110","competitor"),
  makeVisit("AA-004","adj-001",10, 52,"442299","adjacent"),
  makeVisit("AA-005","fmg-002",1,  32,"445110","primary"),
  makeVisit("AA-005","cmp-007",2,  22,"445110","competitor"),
  makeVisit("AA-005","adj-004",4,  38,"452311","adjacent"),
  makeVisit("AA-006","mhw-003",4,  48,"444110","primary"),
  makeVisit("AA-006","cmp-002",6,  44,"444110","competitor"),
  makeVisit("AA-007","sna-002",3,  52,"448110","primary"),
  makeVisit("AA-007","cmp-011",5,  28,"448110","competitor"),
  makeVisit("AA-008","fmg-003",2,  24,"445110","primary"),
  makeVisit("AA-008","cmp-006",4,  30,"445110","competitor"),
  makeVisit("AA-008","adj-008",7,  18,"445310","adjacent"),
  makeVisit("AA-009","mhw-001",5,  42,"444110","primary"),
  makeVisit("AA-009","adj-002",8,  78,"442110","adjacent"),
  makeVisit("AA-010","sna-003",1,  36,"448110","primary"),
  makeVisit("AA-010","cmp-009",3,  26,"448110","competitor"),
  makeVisit("AA-011","fmg-001",3,  26,"445110","primary"),
  makeVisit("AA-011","cmp-005",5,  28,"445110","competitor"),
  makeVisit("AA-012","mhw-002",6,  40,"444110","primary"),
  makeVisit("AA-012","cmp-004",9,  44,"444110","competitor"),
  makeVisit("AA-013","sna-001",4,  44,"448110","primary"),
  makeVisit("AA-013","cmp-010",6,  30,"448110","competitor"),
  makeVisit("AA-014","fmg-002",2,  30,"445110","primary"),
  makeVisit("AA-014","adj-007",5,  20,"444130","adjacent"),
  makeVisit("AA-015","mhw-003",3,  46,"444110","primary"),
  makeVisit("AA-015","adj-005",6,  52,"713940","adjacent"),
  makeVisit("AA-016","sna-002",5,  38,"448110","primary"),
  makeVisit("AA-016","cmp-011",7,  24,"448110","competitor"),
  makeVisit("AA-017","fmg-003",1,  28,"445110","primary"),
  makeVisit("AA-017","cmp-008",3,  32,"445110","competitor"),
  makeVisit("AA-018","mhw-001",7,  50,"444110","primary"),
  makeVisit("AA-018","cmp-001",10, 48,"444110","competitor"),
  makeVisit("AA-019","sna-003",2,  40,"448110","primary"),
  makeVisit("AA-019","cmp-009",4,  28,"448110","competitor"),
  makeVisit("AA-020","fmg-001",4,  24,"445110","primary"),
  makeVisit("AA-020","adj-006",6,  16,"722515","adjacent"),
  makeVisit("AA-021","mhw-002",8,  44,"444110","primary"),
  makeVisit("AA-022","sna-001",3,  48,"448110","primary"),
  makeVisit("AA-023","fmg-002",5,  26,"445110","primary"),
  makeVisit("AA-024","mhw-003",2,  42,"444110","primary"),
];

// ── Monthly foot traffic trend (12 months) ────────────────────
export interface MonthlyTraffic {
  month:    string;
  mhw:      number;
  fmg:      number;
  sna:      number;
  mhw_comp: number;  // primary competitor
  fmg_comp: number;
  sna_comp: number;
}

export const MONTHLY_TRAFFIC: MonthlyTraffic[] = [
  { month:"Apr'25", mhw:16_200, fmg:38_400, sna:24_200, mhw_comp:22_400, fmg_comp:44_800, sna_comp:31_200 },
  { month:"May'25", mhw:17_800, fmg:40_200, sna:26_400, mhw_comp:23_200, fmg_comp:46_200, sna_comp:32_800 },
  { month:"Jun'25", mhw:19_400, fmg:41_800, sna:28_800, mhw_comp:24_400, fmg_comp:47_600, sna_comp:34_400 },
  { month:"Jul'25", mhw:20_100, fmg:42_400, sna:30_200, mhw_comp:24_800, fmg_comp:48_200, sna_comp:35_200 },
  { month:"Aug'25", mhw:19_200, fmg:43_200, sna:29_400, mhw_comp:24_200, fmg_comp:49_000, sna_comp:34_800 },
  { month:"Sep'25", mhw:17_800, fmg:41_600, sna:27_200, mhw_comp:23_400, fmg_comp:47_400, sna_comp:33_200 },
  { month:"Oct'25", mhw:18_200, fmg:40_800, sna:26_800, mhw_comp:23_800, fmg_comp:46_800, sna_comp:32_600 },
  { month:"Nov'25", mhw:20_400, fmg:48_200, sna:32_400, mhw_comp:25_200, fmg_comp:54_200, sna_comp:40_200 },
  { month:"Dec'25", mhw:22_800, fmg:52_400, sna:38_800, mhw_comp:26_400, fmg_comp:58_400, sna_comp:46_800 },
  { month:"Jan'26", mhw:15_200, fmg:38_200, sna:22_400, mhw_comp:21_400, fmg_comp:44_200, sna_comp:28_800 },
  { month:"Feb'26", mhw:16_400, fmg:39_800, sna:24_800, mhw_comp:22_200, fmg_comp:45_600, sna_comp:30_400 },
  { month:"Mar'26", mhw:18_420, fmg:42_180, sna:28_640, mhw_comp:23_600, fmg_comp:47_200, sna_comp:33_800 },
];